import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import optimizeAndConvertToWebP from '../../utils/optimizeAndConvertToWebP';
import {generateTeamCodeFromName} from '../../utils/teamUtils';


const AddTeamModal = ({ open, onClose, onAdd }) => {
  const [formValues, setFormValues] = useState({
    name: '',
    teamCode: '',
    logo: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => {
      const newValues = { ...prev, [name]: value };
      if (name === 'name') {
        // Autogenera el teamCode
        newValues.teamCode = generateTeamCodeFromName(value);
      }
      return newValues;
    });
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const optimized = await optimizeAndConvertToWebP(file);
      if (optimized) {
        setFormValues((prev) => ({ ...prev, logo: optimized }));
      }
    }
  };

  const handleSubmit = () => {
    const newTeam = {
      id: uuidv4(),
      name: formValues.name,
      teamCode: formValues.teamCode || generateTeamCodeFromName(formValues.name),
      logoEquipo: formValues.logo,
    };
    onAdd(newTeam);
    // Limpiamos el form
    setFormValues({ name: '', teamCode: '', logo: '' });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Agregar Nuevo Equipo</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Ingrese la información del nuevo equipo.
        </DialogContentText>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Nombre del Equipo"
            name="name"
            value={formValues.name}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Team Code"
            name="teamCode"
            value={formValues.teamCode}
            onChange={handleChange}
            fullWidth
            helperText="Código generado a partir del nombre (puedes editarlo si quieres)"
          />
          <Button variant="outlined" component="label">
            Subir Logo
            <input type="file" hidden accept="image/*" onChange={handleLogoChange} />
          </Button>
          {formValues.logo && (
            <Box>
              <img
                src={formValues.logo}
                alt="Logo del Equipo"
                style={{ maxWidth: '100%', maxHeight: 100 }}
              />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddTeamModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddTeamModal;
